import { render, staticRenderFns } from "./MerchandisesPreview.vue?vue&type=template&id=275728c2&scoped=true&"
import script from "./MerchandisesPreview.vue?vue&type=script&lang=js&"
export * from "./MerchandisesPreview.vue?vue&type=script&lang=js&"
import style0 from "./MerchandisesPreview.vue?vue&type=style&index=0&id=275728c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275728c2",
  null
  
)

export default component.exports